import { 
    fixedHeader, 
    mainMenu, 
    setEqualHeight,
    initTextFillAnimation,
    imageAnimation,
    textAnimation,
    setupScrollTo,
    handleSectionScrollFromQuery,
    anchorLinkHandler,
    updateDiscountInputs
} from './parts/helpers';

import {
    initializeTestimonialsSliders,
    initializeMobileCompleatedProjects,
    initializeProjectSliders
} from './parts/sliders';

import { popupHandler } from './parts/popup';

// import fslightbox
require('fslightbox');

const init = () => {    
    
    // Fixed headar
    fixedHeader();

    // Mobile menu click
    mainMenu();

    // Initialize scroll on click
    setupScrollTo();
    handleSectionScrollFromQuery();
   
    //Set equal height
    setEqualHeight('js-equal-height');

    // Initialize text fill animation
    initTextFillAnimation();

    // Initialize animations
    imageAnimation();
    textAnimation();

    // Initialize sliders
    initializeTestimonialsSliders();
    initializeMobileCompleatedProjects();
    initializeProjectSliders();

    window.document.addEventListener('scroll', () => {
        fixedHeader();
        imageAnimation();
        textAnimation();
    });

    // Initialize popup
    popupHandler(vars_from_php);    

    anchorLinkHandler();
    updateDiscountInputs();
}

window.document.addEventListener('DOMContentLoaded', init);


